mama-gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  gap: 1.25rem;

  @include media-breakpoint-up(md) {
    grid-template-columns: repeat(3, 1fr);
  }

  mama-gallery-item:first-child {
    width: 100%;
    grid-column: 1 / -1;
  }
}
